import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=6f23a941&scoped=true"
import script from "./Chips.vue?vue&type=script&lang=js"
export * from "./Chips.vue?vue&type=script&lang=js"
import style0 from "./Chips.vue?vue&type=style&index=0&id=6f23a941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_3gvhbgb4yg4a32yudvtfqrrcqq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23a941",
  null
  
)

export default component.exports